import * as Yup from "yup";

const UserContactSupportSchema = () =>
  Yup.object().shape({
    assigned_to_id: Yup.string().label("Assigned To").nullable(),
    admin_comment: Yup.string().label("Admin Comment").nullable().max(500),
  });

export default UserContactSupportSchema;
